import '../styles/styles.css' //tailwind
import '../public/static/legacy.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'setimmediate'

import { ApolloProvider } from '@apollo/client'
import { GoogleOAuthProvider } from '@react-oauth/google'
import * as Sentry from '@sentry/browser'
import Head from 'next/head'
import React from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { SWRConfig } from 'swr'

import { SignupProvider } from '~/components/auth/SignupContext'
import client from '~/lib/util/fe/apollo-client'
import AuthContextWrapper from '~/lib/util/fe/dataContext/authenticationWrapper'
import fetcher from '~/lib/util/fe/swr-fetch'
import UiPreferences from '~/lib/util/fe/theme/UiPreferences'

Sentry.init({
  dsn: 'https://08fbe008461a448790ff2fa9f4ad143f@o258897.ingest.sentry.io/1453728',
  environment: process.env.RIPPLE_ENV,
  release: process.env.SENTRY_RELEASE,
  enabled: process.env.RIPPLE_ENV !== 'development',
  ignoreErrors: [/.*unrecognized host.*/i]
})

class RippleApp extends React.Component {
  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key])
      })

      Sentry.captureException(error)
    })
  }

  render() {
    const { Component, pageProps } = this.props
    // Per-page layout opt-in (Next.js getLayout pattern). Pages that adopt the
    // new app shell export `Page.getLayout`; everything else passes through.
    const getLayout = Component.getLayout || ((page) => page)

    return (
      <>
        <Head>
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
        </Head>
        <UiPreferences />
        <GoogleOAuthProvider
          clientId={
            process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ||
            '317732524400-ctsl4gb4aiu93vu3fq4ek8fho54relsp.apps.googleusercontent.com'
          }
        >
          <DndProvider backend={HTML5Backend}>
            <SWRConfig
              value={{
                refreshInterval: 20000,
                fetcher
              }}
            >
              <ApolloProvider client={client}>
                <AuthContextWrapper>
                  <SignupProvider>
                    {getLayout(<Component {...pageProps} />)}
                  </SignupProvider>
                </AuthContextWrapper>
              </ApolloProvider>
            </SWRConfig>
          </DndProvider>
        </GoogleOAuthProvider>
      </>
    )
  }
}

export default RippleApp
